var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.6109 6.24629C7.54589 5.10288 9.75243 4.49919 12 4.5C14.2476 4.49919 16.4541 5.10288 18.3891 6.24629C20.3241 7.38969 21.9165 9.03084 23 11V13C21.9154 14.968 20.3226 16.6099 18.3878 17.7527C16.4531 18.8956 14.2471 19.5 12 19.5C9.7529 19.5 7.54694 18.8956 5.61216 17.7527C3.67738 16.6099 2.08463 14.968 1 13V11C2.08349 9.03084 3.67591 7.38969 5.6109 6.24629ZM12 15.5C14.4853 15.5 16.5 13.4853 16.5 11C16.5 8.51472 14.4853 6.5 12 6.5C9.51472 6.5 7.5 8.51472 7.5 11C7.5 13.4853 9.51472 15.5 12 15.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeFilled);
export default __webpack_public_path__ + "static/media/eyeFilled.a4a2f0913a01fa6b4494b41b6a1eb244.svg";
export { ForwardRef as ReactComponent };